var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"surprise-box"}},[_c('div',{class:{ blur: _vm.blurAnim },attrs:{"refs":"lottie","id":"lottie"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }